import { Injectable } from '@angular/core';
import { JobDeleteImpact, ProjectDeleteImpact } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  private list(values: number[] | undefined): string {
    return values && values.length > 0 ? values.join(', ') : '-';
  }

  confirmJobDelete(projectId: string, jobId: number, impact?: JobDeleteImpact): boolean {
    if (!impact) {
      return confirm(`Wollen Sie Job ${projectId}.${jobId} wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!`);
    }

    const message =
      `Wollen Sie Job ${projectId}.${jobId} wirklich löschen?\n\n` +
      'Es werden mitgelöscht:\n' +
      `- Job-Positionen: ${impact.job_positions || 0}\n` +
      `- Auftragsbestätigungen (IDs): ${this.list(impact.confirmations)}\n` +
      `- Mitteilungen (IDs): ${this.list(impact.notifications)}\n` +
      `- Bestellungen (IDs): ${this.list(impact.orders)}\n` +
      `- Lieferscheine (IDs): ${this.list(impact.deliveries)}\n` +
      `- Rechnungen (IDs): ${this.list(impact.invoices)}\n\n` +
      'Diese Aktion kann nicht rückgängig gemacht werden!';

    return confirm(message);
  }

  confirmProjectDelete(cid: number, pid: string, impact?: ProjectDeleteImpact, intro?: string): boolean {
    if (!impact) {
      const defaultText = intro || `Projekt ${cid}.${pid} löschen?`;
      return confirm(`${defaultText}\nDiese Aktion kann nicht rückgängig gemacht werden!`);
    }

    const header = intro || `Projekt ${cid}.${pid} löschen?`;
    const message =
      `${header}\n\n` +
      'Es werden mitgelöscht:\n' +
      `- Anfragen: ${this.list(impact.requests)}\n` +
      `- Angebote: ${this.list(impact.offers)}\n` +
      `- Jobs: ${this.list(impact.jobs)}\n` +
      `- Bestellungen: ${this.list(impact.orders)}\n` +
      `- Auftragsbestätigungen: ${this.list(impact.confirmations)}\n` +
      `- Mitteilungen: ${this.list(impact.notifications)}\n` +
      `- Lieferscheine: ${this.list(impact.deliveries)}\n` +
      `- Rechnungen: ${this.list(impact.invoices)}\n` +
      `- Transporte: ${this.list(impact.transports)}\n\n` +
      'Diese Aktion kann nicht rückgängig gemacht werden!';

    return confirm(message);
  }
}
